import {action, makeAutoObservable} from "mobx"
import ElementModel from "../../model/ElementModel";
import {RootStore} from "../index";

export class PageMainStore {
    private rootStore: RootStore | undefined;

    arItemsNew = [];
    arItemsSpecials = [];
    arItemsStock = [];
    arItemsLoyalty = [];
    
    isEmptyResultNew = false;
    isEmptyResultSpecials = false;
    isEmptyResultStock = false;
    isEmptyResultLoyalty = false;

    public error: string = '';

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init() {
      //  this.arItemsNew=[];
      //  this.arItemsSpecials=[];
      //  this.arItemsStock=[];
        let ClientId=this.rootStore?.mainStore.getClientId();
        const limit=10;

        ElementModel.getCatalog({
            json: {
                clientId: ClientId,
                limit: limit,
                filter: {
                    props: {isNovelty: true}
                }
            }
        }, this.setCatalogNew, this.setError);
        ElementModel.getCatalog({
            json: {
                clientId: ClientId,
                limit: limit,
                filter: {
                    props: {isSellout: true}
                }
            }
        }, this.setCatalogSpecials, this.setError);
        ElementModel.getCatalog({
            json: {
                clientId: ClientId,
                limit: limit,
                filter: {
                    props: {isSale: true}
                }
            }
        }, this.setCatalogStock, this.setError);
        ElementModel.getCatalog({
            json: {
                clientId: ClientId,
                limit: limit,
                filter: {
                    props: {isIncludeLoyaltyProgram: true}
                }
            }
        }, this.setCatalogLoyalty, this.setError);
    }

    @action
    setCatalogNew = (result: any) => {
        this.arItemsNew = result.data.rows;
        this.isEmptyResultNew = result.data.rows && result.data.rows.length === 0;
    }

    @action
    setCatalogSpecials = (result: any) => {
        this.arItemsSpecials = result.data.rows;
        this.isEmptyResultSpecials = result.data.rows && result.data.rows.length === 0;
    }

    @action
    setCatalogStock = (result: any) => {
        this.arItemsStock = result.data.rows;
        this.isEmptyResultStock = result.data.rows && result.data.rows.length === 0;
    }
    @action
    setCatalogLoyalty = (result: any) => {
        this.arItemsLoyalty = result.data.rows;
        this.isEmptyResultLoyalty = result.data.rows && result.data.rows.length === 0;
    }

    @action
    setError = (error: any) => {
        console.log(error);
        // this.error = error.response.data.message;
    }


}
